import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #22cfae;
  height: 20px;
  width: 20px;
`
export const DestinationIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.41659 20.3048C7.61993 20.3048 3.83514 15.6261 2.90779 14.1208C1.52473 11.8707 0.687012 10.5119 0.687012 7.92922C0.687012 5.8791 1.50142 3.91294 2.95108 2.46328C4.40073 1.01363 6.36689 0.199219 8.41701 0.199219C10.4671 0.199219 12.4333 1.01363 13.8829 2.46328C15.3326 3.91294 16.147 5.8791 16.147 7.92922C16.147 10.408 15.321 11.7467 13.953 13.9658L13.8584 14.1199C12.9025 15.6689 9.19818 20.3048 8.41659 20.3048ZM8.41659 4.06485C7.65213 4.06485 6.90483 4.29154 6.2692 4.71625C5.63357 5.14097 5.13815 5.74463 4.84561 6.45091C4.55306 7.15718 4.47651 7.93434 4.62565 8.68412C4.77479 9.4339 5.14292 10.1226 5.68348 10.6632C6.22404 11.2037 6.91275 11.5719 7.66253 11.721C8.4123 11.8701 9.18947 11.7936 9.89574 11.501C10.602 11.2085 11.2057 10.7131 11.6304 10.0775C12.0551 9.44182 12.2818 8.69452 12.2818 7.93006C12.2807 6.90528 11.8731 5.92279 11.1485 5.19817C10.4239 4.47354 9.44137 4.06596 8.41659 4.06485Z"
        fill="#22CFAE"
      />
    </Svg>
  )
}
